export default {
    'Background Image': "Hintergrundbild",
    'Internal media storage is empty.': 'Der interne Medienspeicher ist leer.',
    'Insert background image': 'Hintergrundbild einfügen',
    'Remove background image': 'Hintergrundbild entfernen',
}